import styled from 'styled-components';
// import { white } from '../../common/colors';
import { StyledSliderTwoContainer } from '../../common/sliderTwo.styles';

export const StyledTitleCarouselTwo = styled.section`
  background-color: transparent;
`;

export const StyledTitleSliderTwoContainer = styled(StyledSliderTwoContainer)`
  position: relative;
  overflow: hidden;
  padding-bottom: 30px;

  .slick-slider {
    position: static;
  }
`;

/* export const StyledTitleCarouselTwo = styled.section`
  background-color: ${white};
`;

export const StyledTitleSliderTwoContainer = styled(StyledSliderTwoContainer)`
  position: relative;
  overflow: hidden;

  .slick-slider {
    position: static;
  }
`; */
